/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IInitOauthIntegrationAuthMutationVariables = Types.Exact<{
  provider: Types.OauthIntegrationProviderEnum;
  options?: Types.InputMaybe<Types.IIntegrationAuthOptionsInput>;
}>;

export type IInitOauthIntegrationAuthMutation = {
  __typename?: 'Mutation';
  initOauthIntegrationAuth?: {
    __typename?: 'InitAuthPayload';
    success: boolean;
    errors?: Array<string> | null;
    integrationAuth?: { __typename?: 'IntegrationAuth'; url: string; stateToken: string } | null;
  } | null;
};

export const InitOauthIntegrationAuthDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'initOauthIntegrationAuth' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'OauthIntegrationProviderEnum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'options' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'IntegrationAuthOptionsInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'initOauthIntegrationAuth' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'provider' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'options' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'options' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'integrationAuth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateToken' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IInitOauthIntegrationAuthMutation, IInitOauthIntegrationAuthMutationVariables>;
